import {BaseContainerModel} from '../../base-container.model';
import {bl_cms_widget_instance_ext_RowClass} from '../../../dbschema';


export class WidgetInstanceExtensionContainerModel extends BaseContainerModel {
  bl_cms_widget_instance_ext: bl_cms_widget_instance_ext_RowClass = new bl_cms_widget_instance_ext_RowClass();
}
